module.exports = __webpack_public_path__ + "img/wtesoriere.8c0d63ad.png";